module.exports = __webpack_public_path__ + "static/media/wirecutter-nasa.7c7586a3.png";